// extracted by mini-css-extract-plugin
export default {"search":"DropdownSearch_search__fCVrr","border-autocomplete":"DropdownSearch_border-autocomplete__h1PiV","listbox-height":"DropdownSearch_listbox-height__VauHZ"};